export default __webpack_public_path__ + "static/media/visa.inline.032db93b.svg";